import * as CounterService from "../../services/counter-service";

export const NOT_SET = -1;

const REFRESH_TIMER = 30 * 1000; // 30 seconds in millis
let timerId;
let generation = 0;
let latestRequest = 0;

export function register(callback) {
  unregister();
  fetchCounter(callback);
  timerId = setInterval(function () {
    fetchCounter(callback);
  }, REFRESH_TIMER);
}

export function fetchCounter(callback) {
  const currentGeneration = generation;
  const requestId = ++latestRequest;
  const isCurrent = () =>
    currentGeneration === generation && requestId === latestRequest;
  return CounterService.getMenuCounters()
    .then((response) => {
      if (isCurrent()) {
        callback(response.data.count1, response.data.count2);
      }
    })
    .catch((err) => {
      if (isCurrent()) {
        callback(NOT_SET, NOT_SET);
      }
    });
}

export function unregister() {
  clearInterval(timerId);
  timerId = undefined;
  generation++;
}
